<template>
  <div class="box5" id="box5">
    <pageTitle title="专业介绍" />

    <div class="subject-content" >
      <div class="top" id="eleTop">
        <div class="wrapper">
          <a :class="curTab == 0 ? 'current' : ''" @click="clickTab(0)">MCIT</a>
          <a :class="curTab == 1 ? 'current' : ''" @click="clickTab(1)">MSCS</a>
        </div>
      </div>
      <div v-if="curTab == 0" class="bottom">
        <h1>计算机信息技术硕士（MCIT）</h1>
        <div class="item" v-for="(item,index) in list1" :key="index">
          <h2 v-html="item.h1"></h2>
          <p>
            {{item.p}}
          </p> 
          <ul>
            <li v-for="(itemInner,indexInner) in item.content" :key="indexInner" :class="itemInner.isExpand?'current':''">
              <div class="title" @click="clickFn(itemInner,indexInner,index)">
                <div class="left">
                  <b>{{itemInner.title}}</b>
                  <i v-if="itemInner.title2">{{itemInner.title2}}</i>
                </div>
                <div class="right"  :class="{ 'img-rotate': itemInner.isExpand}">
                  <img
                    src="../../../assets/coursePage/ai/box6/icon-down.png"
                    alt
                  />
                </div>
              </div>
              <div class="content">
                <i v-if="item.type==1">{{itemInner.txt}}</i>

                <template v-if="item.type==3">
                  <template v-if="indexInner==1">
                    <div class="btn-box">
                      <a @click="changeCur(index,indexInner,indexInner2)" :class="itemInner.cur==indexInner2?'current':''" v-for="(itemInner2,indexInner2) in itemInner.arr" :key="indexInner2">{{itemInner2.title}}</a>
                    </div>
                    <img  :src="itemInner.arr[itemInner.cur].img"/>
                  </template>
                  <img v-else :src="itemInner.img"/>
                </template>

                <template v-if="item.type==2">
                  <div class="wrapper" v-for="(itemInner3,indexInner3) in itemInner.arr" :key="indexInner3">
                    <i>·</i>
                    <span>
                      <h1>{{itemInner3.h1}}</h1>
                      <p v-html="itemInner3.p"></p>
                    </span>
                  </div>
                </template>
              </div>
            </li>
           
          </ul>
        </div>
        <div class="item item2">
          <h2>04 国内外知名师资</h2>
          <div class="subject-box">
              <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
                <swiper-slide
                  class="swiperwrap"
                  v-for="(item, index) in listSwiper1"
                  :key="index"
                >
                  <div class="box">
                    <img :src="item.img" alt="" />
                    
                  </div>
                </swiper-slide>
              </swiper>
              <div class="swiper-pagination-box2"></div>
            </div>
        </div>
      </div>
      <div v-else class="bottom">
        <h1>计算机科学硕士（MSCS）</h1>
        <div class="item" v-for="(item,index) in list2 " :key="index">
          <h2 v-html="item.h1"></h2>
          <p> 
            {{item.p}}
          </p> 
          <ul>
            <li v-for="(itemInner,indexInner) in item.content" :key="indexInner" :class="{'current':itemInner.isExpand,'li2':index==1}">
              <div class="title" @click="clickFn(itemInner,indexInner,index,2)">
                <div class="left">
                  <b>{{itemInner.title}}</b>
                  <i v-if="itemInner.title2">{{itemInner.title2}}</i>
                </div>
                <div class="right"  :class="{ 'img-rotate': itemInner.isExpand}">
                  <img
                    src="../../../assets/coursePage/ai/box6/icon-down.png"
                    alt
                  />
                </div>
              </div>
              <div class="content">
                <i v-if="item.type==1">{{itemInner.txt}}</i>

              </div>
            </li>
           
          </ul>
        </div>
        <div class="item item2">
          <h2>03 国内外知名师资</h2>
          <div class="subject-box">
              <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
                <swiper-slide
                  class="swiperwrap"
                  v-for="(item, index) in listSwiper2"
                  :key="index"
                >
                  <div class="box">
                    <img :src="item.img" alt="" />
                    
                  </div>
                </swiper-slide>
              </swiper>
              <div class="swiper-pagination-box2"></div>
            </div>
        </div>
      </div>
    </div>
    <div  id="box6Height"></div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
 
  data() {
    return {
      curTab:0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 20,
        slidesPerView: "auto",
        autoplay: true,
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box2",
        },
      },
      listSwiper1: [
        {
          img: require("../../../assets/coursePage/nau/box5/teacher1-1.png"),
        },
        {
          img: require("../../../assets/coursePage/nau/box5/teacher1-2.png"),
        },
        {
          img: require("../../../assets/coursePage/nau/box5/teacher1-3.png"),
        },
      ],
      listSwiper2: [
        {
          img: require("../../../assets/coursePage/nau/box5/teacher2-1.png"),
        },
        {
          img: require("../../../assets/coursePage/nau/box5/teacher2-2.png"),
        },
        {
          img: require("../../../assets/coursePage/nau/box5/teacher2-3.png"),
        },
        {
          img: require("../../../assets/coursePage/nau/box5/teacher2-4.png"),
        },
      ],
      list1:[{
        cur:0,
        type:1,
        h1:'01 专业详情',
        p:'NAU的计算机信息技术硕士项目计划培养学生了解信息技术对组织的影响、技术创新对全球化的影响、变化和缓解变化的理论，以及在技术环境中开展研究的价值。该项目将讲授理论模型、布置工程实践项目、介绍最新研究实例，为学生提供根植于计算机信息技术理论，能够解决商业应用问题的技术经验。',
        content:[{
          title:'学制',
          txt:'标准学制为12个月',
          isExpand:false,
        },{
          title:'毕业要求',
          isExpand:false,
          txt:'本项目包含10门课程，学员通过所有课程的作业审核，即可修满分30学分顺利毕业，并获得北亚利桑那大学颁发的硕士学位证书 '
        },{
          title:'上课形式',
          isExpand:false,
          txt:'课程内容包括教授的录播视频与配套学习材料。支持教授在线答疑和线上互动，并由资深教务跟进学员学习进度，提供科学的学习建议和教学教导'
        },{
          title:'作业形式',
          isExpand:false,
          txt:'每门课程需要完成不同类型的作业，包括项目提案，案例分析录音演讲、论文撰写等'
        }],
      },{
        cur:0,
        type:2,
        h1:'02 热门专业方向',
        
        p:'北亚利桑那大学计算机信息技术硕士总共包含4个专业方向',
        content:[{
          title:'项目管理',
          isExpand:false,
          arr:[{
            h1:'适合人群',
            p:'质量把控、管理层、高层；希望进一步优化公司内部开发流程和管理方法，实现管理综合能力的进阶。'
          },{
            h1:'学习内容',
            p:'项目管理、信息技术管理原理、项目计划与调度、项目沟通，领导及相关利益者管理、项目风险和成本管理。'
          },{
            h1:'学习收获',
            p:'通过本专业，你将学习项目的规划、执行和控制等方面的成功实践，以及领导力和沟通技能将对全方位教授和辅助学生建立和管理项目的能力。'
          },{
            h1:'热门就业岗位',
            p:'项目经理、项目工程师、项目计划与监控工程师、项目融资、项目合同管理、项目财务经理。'
          }]
        },{
          title:'数据分析 ',
          isExpand:false,
          arr:[{
            h1:'适合人群',
            p:'技术开发、数据分析师；进入数据分析、大数据、人工智能领域工作，或计划进一步提升数据分析能力的专业人士。'
          },{
            h1:'学习内容',
            p:'数据分析、数据库进阶、大数据、数据挖掘。'
          },{
            h1:'学习收获',
            p:'该方向将学习数据分析的基础知识和最佳实践，包括数据建模和分析，大数据应用和云计算等。在完成该专业学习后你将具备编写高质量数据分析报告的能力。'
          },{
            h1:'热门就业岗位',
            p:'数据分析工程师、数据挖掘工程师、数据架构师、BI报表分析员、大数据分析师、数据产品经理。'
          }]
        },{
          title:'信息安全',
          isExpand:false,
          arr:[{
            h1:'适合人群',
            p:'管理层、技术开发、信息安全从业者；目前从事高保密级别工作，或是需要信息安全背景的人士，例如银行、保险、证券等相关国家监管力度较大的从业者。'
          },{
            h1:'学习内容',
            p:'网络安全政策与原理、网络安全与风险管理、数字取证与犯罪调查基础、信息安全设计:基础设施和管理。'
          },{
            h1:'学习收获',
            p:'该专业教学涵盖所有信息安全领域，包括网络安全、应用安全和数据安全等方面。在学习本专业之后，你将能够保护企业的信息系统免受黑客和病毒的侵害。'
          },{
            h1:'热门就业岗位',
            p:'网络安全工程师、渗透测试工程师、安全运维、信息安全风评估分析师、信息安全总监、应用安全工程师。'
          }]
        },{
          title:'软件工程 ',
          isExpand:false,
          arr:[{
            h1:'适合人群',
            p:'零基础、技术开发、技术管理层；零基础但计划从事技术开发相关工作的人士，或是希望进一步提升技术能力和教育背景的业内专业人士。'
          },{
            h1:'学习内容',
            p:'软件工程、移动和Web应用程序开发、安卓应用程序开发、ISO应用程序开发。'
          },{
            h1:'学习收获',
            p:'软件工程方向注重培养学生在移动和Web应用程序开发方面的技能，让你的程序创意想法得到完美实现。这个课程帮助你掌握最新的技术和工具，包括移动应用程序开发技术，Web设计和开发技术等。'
          },{
            h1:'热门就业岗位',
            p:'WEB开发、移动互联网开发、大数据开发、应用开发工程师、IOS软件开发工程师、安卓开发工程师。'
          }]
        }],
      },{
        cur:0,
        type:3,
        h1:'03 课程内容',
        p:'北亚利桑那大学计算机信息技术硕士毕业需完成10门课程（共30学分），包括4门必修核心课，和对应专业方向的6门进阶课。项目管理，数据分析，信息安全，软件工程四个分支方向可在核心课程结束后自由选择。',
        content:[{
          title:'核心课',
          isExpand:false,
          img: require("../../../assets/coursePage/nau/box5/img-core.png"),
        },{
          title:'进阶课',
          cur:0,
          isExpand:false,
          arr:[{
            title:'项目管理',
            img: require("../../../assets/coursePage/nau/box5/img01.png"),
          },{
            title:'数据分析',
            img: require("../../../assets/coursePage/nau/box5/img02.png"),
          },{
            title:'信息安全',
            img: require("../../../assets/coursePage/nau/box5/img03.png"),
          },{
            title:'软件工程',
            img: require("../../../assets/coursePage/nau/box5/img04.png"),
          }]
        }],
      }],
      list2:[{
        cur:0,
        type:1,
        h1:'01 专业详情',
        p:'美国沉淀了计算机领域主要的基础研究和科研成果，这些科研成果往往由高校研究者开启，并快速实现产业化，这使美国计算机科学教育明显区别于他国。北亚利桑那大学注重理论与实践相结合的理念，推动着研究与产业之间的快速转化，因此北亚利桑那大学的计算机科学内容不仅前沿，且具有极强的实用性。',
        content:[{
          title:'学制',
          txt:'标准学制为1.5年',
          isExpand:false,
        },{
          title:'毕业要求',
          isExpand:false,
          txt:'本项目包含10门课程，学员通过所有课程的作业审核，即可修满分30学分顺利毕业，并获得北亚利桑那大学颁发的硕士学位证书'
        },{
          title:'上课形式',
          isExpand:false,
          txt:'课程内容包括教授的录播视频与配套学习材料。支持教授在线答疑和线上互动，并由资深教务跟进学员学习进度，提供科学的学习建议和教学教导'
        },{
          title:'作业形式',
          isExpand:false,
          txt:'五个常规作业的设定激励你合理安排时间并完成目标，有效提升日常工作中的时间管理和信息整合能力'
        }],
      },{
        cur:0,
        type:1,
        h1:'02 课程内容 ',
        p:'北亚利桑那大学计算机科学硕士（MSCS）毕业需要完成10门课程（共30学分） ',
        content:[{
          title:'编程和数据结构简介 - CS 599',
          title2:'Introduction to Programming and Data Structures',
          txt:'本课程介绍编程和数据结构的基础知识，以C语言为基础语言，学习查询、排序、组合等算法的实现和时间复杂度。同时学习树、哈希表、递归等数据结构和算法的概念和应用。',
          isExpand:false,
        },{
          title:'软件开发方法论 - INF 502',
          title2:'Introduction to Programming and Data Structures',
          isExpand:false,
          txt:'本课程以Python为基础语言，涵盖算法、项目管理、数据收集、数据分析等实用技能，深入剖析算法是如何解决实际问题、软件如何通过版本迭代提高质量，及如何进行更高效的数据分析等实用性问题。'
        },{
          title:'大规模数据结构和组织 - INF 503',
          title2:'Large Scale Data Structures and Organization',
          isExpand:false,
          txt:'通过本课程可掌握C和C++编程的基本概念，并编写解决简单问题的程序，同时学习数据结构相关知识，来解决相应计算问题，如堆栈、列表、队列、链表、树、后缀树、哈希表、内存管理、访问和搜索时间属性、随机数生成、概率质量函数和计算模拟等，能够以计算机科学视角进行问题求解的过程，运用计算思维解决现实生活问题。'
        },{
          title:'计算机网络 - CS 560',
          title2:'Computer Networks',
          isExpand:false,
          txt:'本课程介绍计算机网络的基本概念，按照自上而下的次序，系统地对各层次(应用层、传输层、网络层、数据链路层和物理层)的主要服务、工作原理、常用技术和重要协议进行阐述，理解计算机网络的相关知识。'
        },{
          title:'人工智能 - CS 570',
          title2:'Artificial Intelligence',
          isExpand:false,
          txt:'本课程介绍人工智能的基本定义以及人工智能要解决的问题，包括如何寻找问题的答案，如何存储知识等。课程内容包括逻辑智能体的概念介绍，多种搜索算法的介绍和实现，掌握如何用逻辑关系式表达语义，以及不确定性环境下的分析和推断等。'
        },{
          title:'并行编程导论 - CS 550',
          title2:'Introduction to Parallel Programming',
          isExpand:false,
          txt:'本课程主要介绍并行计算的概念和实现方式，分为软件部分和硬件部分。软件部分主要讲解如何通过使用一些多线程库，来设计和编写基于共享内存的多线程程序，同时也会涉及分布式内存和程序性能评价方式。硬件部分主要讲解指令流水线、指令级并行、多线程架构以及共享缓存内存等计算机组成层面的并行计算结构。'
        },{
          title:'高性能计算 - CS 552',
          title2:'High Performance Computing',
          isExpand:false,
          txt:'本课程主要介绍和探究高性能计算的相关科学技术，诸如分布式共享内存、点对点通信、聚合通信原语、调度等。同时也会学习如何对高性能计算作性能分析，继而探讨高性能计算的发展趋势。'
        },{
          title:'语言原理+自动机 - CS 501',
          title2:'Principles of Language + Automata',
          isExpand:false,
          txt:'本课程包含多个模块内容，包括Python语言基础知识和使用方法,并从多个角度了解编程语言，包括词法语法分析的相关过程、以及命令式语言、函数式编程、逻辑编程等。'
        },{
          title:'现代回归 - NF 511',
          title2:'Modern Regression',
          isExpand:false,
          txt:'本课程以概率论与数理统计为基础，主要对随机现象进行分析和推断，并对经典的回归分析进一步在理论及应用上进行拓展。通过本课程的学习，可以了解不同类型的数据，理解自变量和因变量的相关性分析，掌握现代回归模型的一些基本理论与方法，并利用回归分析使用R Studio软件解决实际问题。'
        },{
          title:'虚拟世界--计算机图形学 - CS 530',
          title2:'Virtual Worlds--Computer Graphics',
          isExpand:false,
          txt:'本课程主要研究计算机生成、处理和显示图形，通过学习计算机图形学的基本算法，包括基本图形实体、自由曲线和自由曲面的生成算法，图形变换和剪裁，曲面和实体造型算法，颜色、光照模型及真实感图形显示技术与算法等，设计实施并测试光线追踪器常见了解并应用类型的曲线和曲面的数据结构、多边形化和光栅化技术，掌握科学计算可视化、计算机图形处理等方面的内容。本课程是研究VR、AR、元宇宙等概念的重要基础。'
        }],
      },] 
    };
  },

  methods: {
    clickTab(index){
      this.curTab=index
      this.$nextTick(()=>{
        document.getElementById('box5').scrollIntoView({ 
        });
      })
    },
    changeCur(index,indexInner,indexInner2){
      this.list1[index].content[indexInner].cur=indexInner2
    },
    clickFn(itemInner,indexInner,index,type){
      if(type==2){
        this.list2[index].content.forEach((v,i)=>{
          if(i!=indexInner){
            v.isExpand=false
          }
          
        })
        this.list2[index].content[indexInner].isExpand=!this.list2[index].content[indexInner].isExpand
      }else{
        this.list1[index].content.forEach((v,i)=>{
          if(i!=indexInner){
            v.isExpand=false
          }
          
        })
        this.list1[index].content[indexInner].isExpand=!this.list1[index].content[indexInner].isExpand
      }
      
    }
   
  },
};
</script>

<style lang="less" scoped>
.box5 {
  padding: 80px 32px 80px;
  background: #eaf3fd;
  .subject-box {
    position: relative;
    margin: 0 auto 0;
    // padding-bottom: 22px;
    
    width: calc(100%);
    overflow: hidden;
    border-radius: 20px;
    overflow: hidden;
    .swiper-slide {
     
      border-radius: 20px;
    }

    .swiper-pagination-box2 {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      bottom: 0px;
      transform: translate(-50%, 0px);
      height: 6px;
     
    }

    /deep/ .swiper-pagination-bullet {
    width: 12px;
    height: 6px;
    background: rgba(75,132,250,0.36);
    border-radius: 3px;
    margin-right: 8px;
  }
  /deep/ .swiper-pagination-bullet:last-child {
    margin-right: 0px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 24px;
height: 6px;
background: #4B84FA;
border-radius: 3px;
  }

    .swiper-slide {
      width: 100%;
      display: flex;
      justify-content: center;

      box-sizing: border-box;
      .box {
       
        width:100%;
        // height: 512px;
        img {
          width: 100%;
          
        }
        
      }
     
    }
  }

  
  .subject-content {
    overflow-y: auto;
    margin-top: 48px;
    .bottom {
     
      background: rgba(255, 255, 255, 0.6);
      border-radius: 24px;
      overflow: hidden;
      border: 2px solid #ffffff;
      > h1 {
        height: 88px;
        background: linear-gradient(270deg, #eef2fd 0%, #d3dbf3 100%);
        box-shadow: 0px 2px 0px 0px #ffffff;
        border-radius: 24px 24px 0px 0px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #2f3b5f;
        line-height: 88px;
        text-align: center;
        font-style: normal;
      }
      .item2{
        padding: 40px 0 24px !important;
      }
      .item {
        padding: 40px 32px 24px;
        > h2 {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 32px;
          color: #3f6de8;
          line-height: 48px;
          text-align: center;
          font-style: normal;
          margin-bottom: 16px;
        }
        > p {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 24px;
          color: #2f3b5f;
          line-height: 40px;
          text-align: left;
          font-style: normal;
        }
        > ul {
          margin-top: 24px;
          .current{
           
            height:auto !important
          }
          .li2{
            height: 126px;
          }
          li {
            margin-top: 20px;
            background: #ffffff;
            box-shadow: 0px 12px 32px 0px rgba(94, 123, 218, 0.08);
            border-radius: 16px;
            overflow: hidden;
            padding: 0 24px;
            height: 96px;
            transition: 0.5s ease all;
            .title {
              padding: 26px 0;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .left {
                b {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 28px;
                  color: #2f3b5f;
                  line-height: 44px;
                  text-align: left;
                  font-style: normal;
                  display: block;
                }
                i{
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 400;
                  font-size: 20px;
                  color: #597FE5;
                  line-height: 32px;
                  text-align: left;
                  font-style: normal;
                }
              }
              .right {
                width: 28px;
                height: 28px;
                transition: 0.5s ease all;
                margin-right: 5px;
                img {
                  width: 100%;
                  height: 100%;
                }
                
              }
              .img-rotate{
                transition: 0.5s ease all;
              transform: rotate(180deg);
              }
            }
            .content {
              padding: 36px 0 24px;
              border-top: 2px solid #f2f3f5;
              .btn-box{
                display: flex;
                justify-content: space-between;
                margin-bottom: 24px;
                a{
                  width: 132px;
                  height: 64px;
                  background: #F6F6F6;
                  border-radius: 8px;
                  display: block;
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 600;
                  font-size: 24px;
                  color: #4E5969;
                  line-height: 64px;
                  text-align: center;
                  font-style: normal;
                }
                .current{
                  background: linear-gradient( 270deg, #FFD484 0%, #FFB62D 100%);
                  color: #FFFFFF;
                }
              }
              img{
                width: 100%;
              }
              >i {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 24px;
                color: #2f3b5f;
                line-height: 40px;
                text-align: left;
                font-style: normal;
                display: block;
              }
              .wrapper{
                display: flex;
                margin-bottom: 32px;
                >i{
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 600;
                  font-size: 26px;
                  color: #2F3B5F;
                  line-height: 40px;
                  text-align: left;
                  font-style: normal;
                  margin-right: 4px;
                }
                span{
                  h1{
                    font-family: PingFangSC, PingFang SC;
                  font-weight: 600;
                  font-size: 26px;
                  color: #2F3B5F;
                  line-height: 40px;
                  text-align: left;
                  font-style: normal;
                  margin-bottom: 8px;
                  }
                  p{
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 24px;
                    color: #6C7797;
                    line-height: 40px;
                    text-align: left;
                    font-style: normal;
                  }
                }
              }
              .wrapper:last-child{
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
   
    .top {
      width: 100%;
      position: static;
      background: #eaf3fd;
      padding:0 0 32px;
      box-sizing: border-box;
      .wrapper {
        background: #ffffff;
        border-radius: 16px;
        overflow: hidden;
        display: flex;
        height: 88px;
      }
      a {
        width: 50%;
        display: block;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #2f3b5f;
        line-height: 88px;
        text-align: center;
        font-style: normal;
      }
      .current {
        background: linear-gradient(224deg, #86baff 0%, #476ddf 100%);
        color: #ffffff;
      }
    }
    .topFixed{
      position: fixed;
      left: 0;
      top:0;
      z-index: 999;
      .wrapper{
        border-radius: 0;
      }
    }
  }
}
</style>
